import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FlashService } from '../components/flash/flash.service';
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { ReportsService } from './reports.service'
import { QuicksightReportsRolesService } from './quicksight-reports-roles.service';
import { FederatedIdentityGroupService } from '../federated-identity-groups/federated-identity-group.service';
import { NewReportModalComponent } from './new-report/new-report.component';
import { Report } from './report';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: [
        './reports.component.scss',],
    standalone: false
})


export class ReportsComponent implements OnInit{
    reports:Report[];
    selectedReport: Report;
    newReportModal: BsModalRef;
    action;
    loading = false;
    tableConfig = {
    columns: {
      uuid: {
        title: 'uuid',
        width: '250px'
      },

      report_name: {
        title: 'report_name',
        width: '250px'
      },

      roles: {
        title: 'roles',
        width: '200px'
      },

      created_at: {
        title: 'created_at',
        width: '200px',
        compareFunction: (direction, a, b) => {
          return (moment(a).isAfter(b) ? 1 : -1) * direction;
        }
      }
    },
    actions: {
        add: false,
        edit: false,
        delete: false
      }
    }

    titles = Object.keys(this.tableConfig.columns).map(key => this.tableConfig.columns[key].title);
    keys = Object.keys(this.tableConfig.columns)

    constructor(
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private flashService: FlashService,
        private reportsService: ReportsService,
        private quicksightReportsRolesService: QuicksightReportsRolesService,
        private federatedIdentityGroupService: FederatedIdentityGroupService
      ) {}

    ngOnInit() {
        this.route.data.subscribe((data) => {
            this.reports = data.reports.quicksight_reports;
            this.loadRoleAssociations();
          });
    }

    private loadRoleAssociations() {
      this.loading = true;

      // Fetch all roles and role associations in parallel
      forkJoin({
        roles: this.federatedIdentityGroupService.getRoles(),
        roleAssociations: this.quicksightReportsRolesService.list()
      }).subscribe({
        next: ({ roles, roleAssociations }) => {
          const allRoles = roles.roles || [];

          // Create a map of role ID to role name
          const roleMap = new Map();
          allRoles.forEach(role => {
            roleMap.set(role.id, role.name);
          });

          // Group role associations by report ID
          const reportRolesMap = new Map();
          roleAssociations.forEach(association => {
            const reportId = association.quicksight_report_id;
            if (!reportRolesMap.has(reportId)) {
              reportRolesMap.set(reportId, []);
            }
            const roleName = roleMap.get(association.role_id);
            if (roleName) {
              reportRolesMap.get(reportId).push(roleName);
            }
          });

          // Update each report with its role names
          this.reports = this.reports.map(report => ({
            ...report,
            roles: reportRolesMap.has(parseInt(report.id))
              ? reportRolesMap.get(parseInt(report.id)).join(', ')
              : ''
          }));

          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
    }
    
    onRowSelect(event) {
        this.newReportModal = this.modalService.show(NewReportModalComponent, { initialState: { editingReport: true, report: event.data }, class: 'show-modal'});
        this.hiddenSubscription(this.modalService)
      }

    public openNewReportModal() {
        this.newReportModal = this.modalService.show(NewReportModalComponent, { initialState: { editingReport: false }, class: 'show-modal'});
        this.hiddenSubscription(this.modalService)
    }

    public determineAction(){
        for(const [key, value] of Object.entries(this.newReportModal.content)){
            if((key === 'added' || key === 'updated' || key === 'deleted') && (value)){
                this.action = key
            }
        }
    }

    public hiddenSubscription(modalService){
        const hiddenSubscription = modalService.onHidden.subscribe(reason => {
            this.determineAction();
              if(this.action){
                  this.newReportModal.content[this.action] = false
                    this.loading = true
          
                  this.flashService.add({
                    type: 'success',
                    message: `<strong>Success!</strong> Report has been ${this.action}.`
                  })
          
                  this.reportsService.list().subscribe(reports => {
                    this.reports = reports.quicksight_reports;
                    this.loadRoleAssociations();
                  })
                  hiddenSubscription.unsubscribe()
              }
          });
    }
}